import { JSX } from "react";
import cx from "classnames";
import { EllipsisTooltip } from "@app/shared/EllipsisTooltip";

interface ProviderTopPrescriptionsProps {
  topPrescriptions?: string[];
  className?: string;
  testId: string;
}

/**
 * ProviderTopPrescriptions component
 * This component displays the top prescriptions for a provider.
 */
const ProviderTopPrescriptions = (props: ProviderTopPrescriptionsProps): JSX.Element => {
  return (
    <div
      className={cx({ [props.className]: !!props.className, "data-box": true })}
      data-testid={props.testId}
    >
      <div className="data-box-header">
        Top Prescriptions
      </div>
      <div className="data-box-content">
        {props.topPrescriptions?.length ? props.topPrescriptions.map((tp, index) => (
          <EllipsisTooltip
            key={index}
            text={tp}
          />
        )) : "No Data is Available"}
      </div>
    </div>
  );
};

export default ProviderTopPrescriptions;